module.exports = __webpack_public_path__ + "img/arr_success.3d939a65.svg";